<button mat-flat-button color="primary" type="button" (click)="scroll()" [ngStyle]="{'visibility': (visibility$ | async), bottom: bottom+'px', position: position}" class="nt-scroll-top">
  <mat-icon>arrow_upward</mat-icon>
</button>
